import gql from 'graphql-tag';

export const AuditScreenQuery = gql`
  query getAuditScreenQuery($first: Int!, $cursor: String!) {
    documentSecurityAudit {
      outsideOrganizationAccess: outsideOrganizationAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
      personalAccountAccess: personalAccountAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
      outsideOwnershipAccess: outsideOwnershipAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
      openLinksAccess(first: $first, cursor: $cursor) {
        nodes {
          ... on Node {
            id
            title
            baseUrl
            url
            modified
            created
            integrationType
            integrationTitle
            category
            owners {
              id
              name
              email
              avatarUrl
            }
            __typename
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const OpenLinksQuery = gql`
  query getOpenLinksQuery($first: Int!, $cursor: String!) {
    documentSecurityAudit {
      openLinksAccess(first: $first, cursor: $cursor) {
        nodes {
          ... on Node {
            id
            title
            baseUrl
            url
            modified
            created
            integrationType
            integrationTitle
            category
            owners {
              id
              name
              email
              avatarUrl
            }
            __typename
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const OutsideOrganizationAccessQuery = gql`
  query getOutsideOrganizationAccessQuery($first: Int!, $cursor: String!) {
    documentSecurityAudit {
      outsideOrganizationAccess: outsideOrganizationAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const PersonalAccountAccessQuery = gql`
  query getPersonalAccountAccessQuery($first: Int!, $cursor: String!) {
    documentSecurityAudit {
      personalAccountAccess: personalAccountAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const OutsideOwnershipAccessQuery = gql`
  query getOutsideOwnershipAccessQuery($first: Int!, $cursor: String!) {
    documentSecurityAudit {
      outsideOwnershipAccess: outsideOwnershipAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const AuditPreloadQuery = gql`
  query getAuditPreloadQuery($first: Int!, $cursor: String!) {
    documentSecurityAudit {
      outsideOrganizationAccess: outsideOrganizationAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
      personalAccountAccess: personalAccountAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
      outsideOwnershipAccess: outsideOwnershipAccessContacts(first: $first, cursor: $cursor) {
        contacts {
          id
          email
          name
          avatarUrl
          integrations {
            title
            type
            integrationNodes(first: 1) {
              nodes {
                ... on Node {
                  id
                  title
                }
              }
              pageInfo {
                total
                hasNextPage
                endCursor
              }
            }
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
      openLinksAccess(first: $first, cursor: $cursor) {
        nodes {
          ... on Node {
            id
            title
            baseUrl
            url
            modified
            created
            integrationType
            category
            owners {
              id
              name
              email
              avatarUrl
            }
            __typename
          }
        }
        pageInfo {
          total
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
